module.exports = __webpack_public_path__ + "static/media/LUNAS.35a6eb0a.jpg";